import { CREATE_MANIP, DELETE_MANIP, UPDATE_MANIP } from '../actions/manips';
import { CREATE_ZONE_SUCCESS, COPY_ZONE_SUCCESS } from '../actions/zones';

export default function(state = false, action) {
  switch (action.type) {
    case CREATE_MANIP:
    case DELETE_MANIP:
    case UPDATE_MANIP:
    case COPY_ZONE_SUCCESS:
    case CREATE_ZONE_SUCCESS:
      return true;
    default:
      return state;
  }
}

export const getIsDirty = state => state.manips.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/dirty.js